import { EVENT_PATH } from "services/firebaseService/storagePaths";
import { ref } from "firebase/database";
import { database } from "../../services/firebaseService/firebaseConfig";

export const USER_BLACKLIST_PATH = "UserBlacklist";

const getEventBlacklistDocRef = (eventId: string) =>
  ref(database, `${EVENT_PATH}/${eventId}/${USER_BLACKLIST_PATH}`);

export default {
  getEventBlacklistDocRef,
};
